/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../../node_modules/@types/bootstrap/index.d.ts" />

export class PrivacyCookieAndTOU {

    Initialize(): void {
        if ($("#ccLearnMore").length > 0) {
            $("#ccLearnMore").on("click", (e) => {
                this.OpenPrivacyWindow();
            });
        }

        if ($("#TCPage").length > 0) {
            $("#TCPage").on("click", (e) => {
                $("#TCPageModel").modal('show');
            });
        }
        
        if ($("#PrivacyPage").length > 0) {
            $("#PrivacyPage").on("click", (e) => {
                $("#PrivacyPageModel").modal('show');
            });
        }

        if ($("#closeTermsWindowOne").length > 0) {
            $("#closeTermsWindowOne").on("click", (e) => {
                this.CloseTermsWindow();
            });
        }

        if ($("#closeTermsWindowTwo").length > 0) {
            $("#closeTermsWindowTwo").on("click", (e) => {
                this.CloseTermsWindow();
            });
        }

        if ($("#privacyStatementLink").length > 0) {
            $("#privacyStatementLink").on("click", (e) => {
                this.OpenPrivacyWindow();
            });
        }

        if ($("#closePrivacyWindowOne").length > 0) {
            $("#closePrivacyWindowOne").on("click", (e) => {
                this.ClosePrivacyWindow();
            });
        }

        if ($("#closePrivacyWindowTwo").length > 0) {
            $("#closePrivacyWindowTwo").on("click", (e) => {
                this.ClosePrivacyWindow();
            });
        }

        if ($("#termsOfUseLink").length > 0) {
            $("#termsOfUseLink").on("click", (e) => {
                this.OpenTermsWindow();
            });
        }

        //if ($("#TCPageModel").length > 0 && $('#PrivacyPageModel').length > 0) {
        //    this.OpenTermsWindow();
        //    this.OpenPrivacyWindow();
        //}
        
        if ($("#TCPageModel").length > 0) {
            this.CloseTermsWindow();
        }
        

        if ($("#PrivacyPageModel").length > 0) {
            this.ClosePrivacyWindow();
        }
    }

    ClosePrivacyWindow(): void {
        $("#PrivacyPageModel").modal('hide');
    }

    CloseTermsWindow(): void {
        $("#TCPageModel").modal('hide');
    }

    OpenTermsWindow(): void {
        $("#TCPageModel").modal('show');
        $('#PrivacyPageModel').modal('hide');
    }

    OpenPrivacyWindow(): void {
        $("#PrivacyPageModel").modal('show');
        $('#TCPageModel').modal('hide');
    }
}

//DOM
((window: any, document: any) => {
    $(() => {
        var privacyCookieAndTOU = new PrivacyCookieAndTOU();
        privacyCookieAndTOU.Initialize();
	});
})(window, document);
